module.exports = __webpack_public_path__ + "static/media/Merriweather-Bold.9ccb885c.ttf";